import * as Yup from 'yup';

import { isValidImage } from './isValidImage';

export const imagesSchema = Yup.array<File>()
  .test('areValidImages', 'Please select valid image files', (value: File[]) => value.every(isValidImage))
  .required();
